import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Legacy localStorage key migration (Tawreed → Sparts rebrand). MUST run
// before './i18n' (reads the language key) and before the React tree mounts
// (AuthContext reads the session key). Side-effect-only import.
import './migrateStorage';
// Sentry init must happen BEFORE App is imported so the SDK is configured
// the first time React's render commits.
import { Sentry } from './sentry';
// i18n bootstrap before App so resources + detector are configured the
// first time any component calls useTranslation().
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Top-level fallback shown when a render error escapes a more specific
 * ErrorBoundary. Deliberately minimal — no router, no auth, no API. If
 * anything in App is broken enough to reach this, we don't want to use
 * more of the same tree.
 */
function FatalFallback() {
  return (
    <div className="min-h-screen grid place-items-center bg-ground p-6 text-center">
      <div className="max-w-md">
        <h1 className="text-xl font-semibold text-ink mb-2">Something went wrong</h1>
        <p className="text-sm text-ink-muted mb-4">
          Refresh the page to try again. If this keeps happening, our team
          has been notified.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-md bg-brand-700 px-4 py-2 text-sm font-medium text-white hover:bg-brand-800"
        >
          Reload
        </button>
      </div>
    </div>
  );
}

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<FatalFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
